/**
 * Left panel of the sign-in layout (sign-in page and two-step setup page). Approved mockup
 * "Sign-in page: adding TechHub", option B, Bill 2026-10-27: warm beige panel, headline covers
 * both parts, Vault and TechHub named, TechHub tagged For MSPs (it only shows for MSP
 * companies) and marked New. To retire the New mark, delete the one <span className="li-new">.
 */
import dvEndorsed from "../assets/brand/dv-endorsed.svg";

export function LoginArt() {
  return (
    <div className="art">
      <div className="brandlock"><img className="login-logo" alt="DocVault from ITAssurance" src={dvEndorsed} /></div>
      <div>
        <h2>Every policy and every client, <em>on the record.</em></h2>
        <p>One place for the knowledge your company runs on.</p>
        <div className="li-parts">
          <div className="li-part">
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 3h7l4 4v14H7z" /><path d="M14 3v4h4M10 12h5M10 16h5" /></svg>
            <div><b>Vault<span className="li-tag">Complete document management system</span></b>
              <span className="li-txt">Policies, procedures, plans and forms. Approved, current, and proof of who has read them.</span></div>
          </div>
          <div className="li-part has-new">
            <svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="5" width="18" height="14" rx="2" /><circle cx="9" cy="11" r="2.2" /><path d="M5.8 16.5c.8-1.6 1.9-2.3 3.2-2.3s2.4.7 3.2 2.3M14.5 10h4M14.5 13.5h3" /></svg>
            <div><b>TechHub<span className="li-tag">For MSPs</span></b>
              <span className="li-txt">Each client's contacts, sites, networks, devices, domains and agreements, with a one-page brief before every call.</span></div>
            <span className="li-new">New</span>
          </div>
        </div>
      </div>
      <div className="art-foot">&copy; {new Date().getFullYear()} ITAssurance</div>
    </div>
  );
}
